import { DELIVERABILITY_INDEX_TYPE_AUDIT, STRIP_HTML_TAG } from 'Constants'
import getIntl from 'Helpers/intl'
import { logAppError } from 'Helpers/logger'
import { pageState } from 'State/page'
import type { PageStateType } from 'Types/state'
import {
  TOAST_VARIANT_ERROR,
  TOAST_VARIANT_SUCCESS,
  toastShow,
} from 'mailup-web-components'
import type { CallbackInterface } from 'recoil'
import {
  getDeliverabilityIndex,
  getUserEmail,
  sendContactRequest,
} from '../services/deliverabilityIndex'
import {
  deliverabilityIndexState,
  modalDeliverabilityIndexContactState,
} from '../state/deliverabilityIndex'

export const deliverabilityIndexCallback =
  ({ set }: CallbackInterface) =>
  async () => {
    try {
      const delIndex = await getDeliverabilityIndex()
      delIndex != null && set(deliverabilityIndexState, delIndex)
    } catch (error) {
      console.error('### error indexDeliverability', error)

      logAppError({
        Component: 'RecipientsList',
        Method: 'deliverabilityIndexCallback',
        appError: error,
      })
    }
  }

export const modalDeliverabilityIndexContactCallback =
  ({ set, snapshot }: CallbackInterface) =>
  async () => {
    const { email } = await snapshot.getPromise(
      modalDeliverabilityIndexContactState,
    )
    let Email = ''
    if (email === '') {
      Email = await getUserEmail()
    }
    set(modalDeliverabilityIndexContactState, (prev) => ({
      ...prev,
      show: true,
      email: Email || prev.email,
      text: getIntl()
        .formatMessage({
          id: 'Load.DeliverabilityIndex.AuditTipUntrustedForm',
        })
        .replace(STRIP_HTML_TAG, ''),
    }))
  }

export const modalDeliverabilityIndexContactCancelCallback =
  ({ set }: CallbackInterface) =>
  async () => {
    set(modalDeliverabilityIndexContactState, (prev) => ({
      ...prev,
      show: false,
    }))
  }

export const modalDeliverabilityIndexContactConfirmCallback =
  ({ set, snapshot, reset }: CallbackInterface) =>
  async () => {
    set(pageState, (prev) => ({
      ...prev,
      loading: true,
    }))

    const { email, text } = await snapshot.getPromise(
      modalDeliverabilityIndexContactState,
    )
    const {
      AuditTip,
      ScoreData: { Score },
    } = await snapshot.getPromise(deliverabilityIndexState)
    const contactData = {
      tipType: DELIVERABILITY_INDEX_TYPE_AUDIT,
      tipSubType: AuditTip,
      email,
      score: Score,
      text,
    }

    try {
      await sendContactRequest(contactData)
      toastShow(
        getIntl().formatMessage({
          id: 'Load.DeliverabilityIndex.ModalToastSuccess',
        }),
        TOAST_VARIANT_SUCCESS,
      )
      set(modalDeliverabilityIndexContactState, (prev) => ({
        ...prev,
        show: false,
      }))
    } catch (error) {
      console.error('### error', error)
      logAppError({
        Component: 'RecipientsList',
        Method: 'modalDeliverabilityIndexContactConfirmCallback',
        appError: error,
      })
      set<PageStateType>(pageState, (prev) => ({
        ...prev,
        status: 'error',
        loading: false,
        errorMessage: getIntl().formatMessage({
          id: 'Load.Alerts.ErrorGeneric',
        }),
      }))
      toastShow(
        getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
        TOAST_VARIANT_ERROR,
      )
    }
    set(pageState, (prev) => ({
      ...prev,
      loading: false,
    }))
  }
